import { useEffect, useState } from "react";
import { getMeteoData } from "../api/meteo";

export const useGetMeteoTemperature = ({ meteoId, start, end }) => {
    const [observations, setObservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTemperatures = async () => {
      try {
        const result = await getMeteoData({
          meteoId,
          start,
          end,
          parameter: "temperature"
        });

        

        setObservations(result);
      } catch (error) {
        setError(error);
        console.error("Error al obtener temperaturas de la meteo:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTemperatures();
  }, [meteoId, start, end]);

  return { observations, loading, error };
};
